import { HubConnectionBuilder, HubConnectionState } from "@microsoft/signalr";
import { SIGNALR_URL } from "../Variables";
import { assertSession, getIdToken } from "./apiClient";

// The hub derives the user from the Firebase token (access_token): no user id is ever sent in the URL.
export function connectNotifications(user, receive, resume, proposal) {
  let disposed = false;
  let retry;
  const connection = new HubConnectionBuilder()
    .withUrl(SIGNALR_URL, {
      accessTokenFactory: async () => { assertSession(user.uid); return getIdToken(); },
      withCredentials: true,
    })
    .withAutomaticReconnect([0, 2000, 10000, 30000])
    .build();
  connection.on("ReceiveNotification", (senderId, message, conversationId) => {
    if (!disposed && conversationId) receive({ senderId, message, conversationId });
  });
  // Only a signal: the receiver refetches its counters from the API, never trusts a pushed number.
  connection.on("PropertyRequestProposal", (payload) => {
    if (!disposed && proposal && payload?.requestId) proposal({ requestId: payload.requestId });
  });
  const start = async () => {
    if (disposed || connection.state !== HubConnectionState.Disconnected) return;
    try {
      await connection.start();
      if (disposed) await connection.stop();
      else resume();
    } catch {
      if (!disposed) retry = setTimeout(start, 5000);
    }
  };
  connection.onreconnected(() => { if (!disposed) resume(); });
  connection.onclose(() => { if (!disposed) retry = setTimeout(start, 5000); });
  start();
  return () => {
    disposed = true;
    clearTimeout(retry);
    connection.off("ReceiveNotification");
    connection.off("PropertyRequestProposal");
    connection.stop().catch(() => {});
  };
}
